import ScoreWheel from "components/ScoreWheel";
import styled, { ThemeProvider } from "styled-components";
import { colors } from "styles";
import getStatus from "utils/getStatus";
import { INTEREST_PER_STATUS } from "config";
import { LOAN_TYPES } from "config";
import calculateLoan from "utils/calculateLoan";

const Root = styled.div`
  background-color: ${colors.white};
  padding: 10px 10px 15px;
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  &:after {
    position: absolute;
    display: block;
    content: "";
    width: 100%;
    height: 7px;
    left: 0;
    bottom: 0;
    background-color: ${(props) => props.theme.colors[1]};
    overflow: hidden;
  }
`;

const Content = styled.div`
  width: 100%;
  padding: 10px;
`;

const Eyebrow = styled.div`
  font-size: 1em;
`;

const Title = styled.div`
  font-size: 1.6em;
  font-weight: bold;
`;

const MoneyValue = styled.div`
  font-size: 1.3em;
`;

const Grid = styled.div`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
`;

const GridItem = styled.li`
  padding-right: 5px;
  & > div {
    display: inline-block;
  }
`;

const Highlight = styled.strong`
  color: ${(props) => props.theme.colors[1]};
`;

const Score = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 20px 0;
`;

const CreditSimulator = ({ score, loanType, person }) => {
  const status = getStatus(score);
  const interest = INTEREST_PER_STATUS[loanType][status.id];
  const { cost, months, img } = LOAN_TYPES[loanType];
  const monthlyPayment = calculateLoan(cost, interest, months);
  const interestCost = monthlyPayment * months - cost;

  return (
    <ThemeProvider theme={status}>
      <Root>
        <Eyebrow>Simulador de crédito personalizado</Eyebrow>
        {person && <Title>{person}</Title>}

        <Score>
          <div>
            <ScoreWheel
              $size="medium"
              score={score}
              disabled
              $trackColor={colors.lightGray}
            />
          </div>

          <img
            src={img}
            alt={loanType}
            style={{
              width: 250,
            }}
          />
        </Score>

        <Content>
          <Grid>
            <GridItem>
              <div>
                <Eyebrow>Valor</Eyebrow>
                <MoneyValue>
                  <Highlight>${cost.toLocaleString()}</Highlight>
                </MoneyValue>
              </div>
            </GridItem>
            <GridItem>
              <div>
                <Eyebrow>
                  <Highlight>{interest}%</Highlight> interes
                </Eyebrow>
                <MoneyValue>
                  <Highlight>-${interestCost.toLocaleString()}</Highlight>
                </MoneyValue>
              </div>
            </GridItem>
            <GridItem>
              <div>
                <Eyebrow>Mensualidad</Eyebrow>
                <MoneyValue>
                  <Highlight>${monthlyPayment.toLocaleString()}</Highlight>
                </MoneyValue>
              </div>
            </GridItem>
          </Grid>
        </Content>
      </Root>
    </ThemeProvider>
  );
};

export default CreditSimulator;
